var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-wrap"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.logoUrl,"alt":"logo"}}),_c('span',{staticClass:"text"},[_vm._v("中国土木工程学会")])])}
var staticRenderFns = []

export { render, staticRenderFns }